import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ColorEvent } from 'ngx-color';
import { takeUntil, Subject } from 'rxjs';
import { CUSTOMIZE_PAYMENT } from 'src/app/constants/endpoint.const';
import { BaseService } from 'src/app/services/base.service';

@Component({
  selector: 'app-payment',
  standalone: false,
  templateUrl: './payment.component.html',
  styleUrl: './payment.component.scss'
})
export class PaymentComponent {
  destroy$ = new Subject();
  loading = false;
  tabValue = 'solid';
  solidColors = ['#940101', '#20853C', '#18908D', '#858C35', '#4E91B8', '#A53953', '#A61E84', '#6C2C6B'];
  customColors = '#940101';
  companyName = '';

  tabMode = 'desktop';

  @ViewChild('fileupload') fileUploadRef!: ElementRef;
  fileUpload: File[] = [];
  uploadedImage: string | null = null;
  isDisableSave: boolean = true;
  photoCompany: File[] = [];
  isDelete: boolean = false;
  photoName: string = '';
  isAvailabeCustomize: boolean = false;

  formGroup: FormGroup = new FormGroup({
    device_type: new FormControl('desktop', [Validators.required]),
    company_name: new FormControl('Raja Ongkir', [Validators.required, Validators.maxLength(100)]),
    background_color: new FormControl('#940101', [Validators.required]),
    logo: new FormControl(null, [Validators.required]),
  });

  constructor(
    private message: NzMessageService,
    private BaseService: BaseService,
  ) { }

  switchTab(value: 'solid' | 'custom') {
    this.tabValue = value;
  }

  switchTabMode(value: 'desktop' | 'mobile') {
    this.tabMode = value;
    this.formGroup.get('device_type')?.setValue(value);
    this.getDataCustomize(value);
  }

  changeColor(value: string) {
    this.customColors = value;
    this.formGroup.get('background_color')?.setValue(value);
  }

  handleChange($event: ColorEvent) {
    this.customColors = $event.color.hex;
    this.formGroup.get('background_color')?.setValue($event.color.hex);
  }

  triggerFileInput() {
    this.fileUploadRef.nativeElement.click();
  }

  handleFileUpload(event: any) {
    const files: File[] = event.target.files;

    const allowedFormats = ['png', 'jpg', 'jpeg'];

    for (let file of files) {
      const fileExtension = file.name.split('.').pop()?.toLowerCase();
      if (!allowedFormats.includes(fileExtension as string)) {
        this.message.create(
          'error',
          'File extension must match .png, .jpg, or .jpeg'
        );
        return;
      }
      if (file.size > 500000) {
        this.message.create('error', 'File size exceeds 500kb limit');
        return;
      }

      const reader = new FileReader();

      reader.onload = (e: any) => {
        this.uploadedImage = e.target.result;
        this.photoName = file.name;
      };

      reader.readAsDataURL(file);
      this.photoCompany.push(file);
      this.isDisableSave = false;
      this.isDelete = false;
      this.formGroup.get('logo')?.setValue(file);
    }
  }

  deleteImage() {
    this.isDelete = true;
    this.uploadedImage = null;
    this.photoCompany = [];
    this.isDisableSave = false;
    this.formGroup.get('logo')?.setValue(null);
  }

  cancel() {
    this.formGroup.reset();
    this.uploadedImage = null;
    this.photoCompany = [];
    this.isDelete = false;
    this.isDisableSave = true;
    this.formGroup.get('background_color')?.setValue('#940101');
    this.customColors = '#940101';
    this.formGroup.get('company_name')?.setValue('');
    this.companyName = '';
    this.formGroup.get('device_type')?.setValue('desktop');
  }

  saveCustomize() {
    if (!this.formGroup.get('logo')?.value) {
      this.message.create('error', 'Company logo is required');
      return;
    }
    this.loading = true;
    const formData = new FormData();
    Object.entries(this.formGroup.value).forEach(([key, value]: [string, any]) => {
      if (key === 'logo' && value === null) {
        formData.append(key, '');
        return;
      }
      if (value) formData.append(key, value);
    });
    if (this.isAvailabeCustomize) {
      this.BaseService
        .putData(CUSTOMIZE_PAYMENT, formData)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res: any) => {
            this.loading = false;
            this.message.create('success', 'Customize saved successfully');
            this.getDataCustomize(this.tabMode);
          },
          error: (err: any) => {
            this.loading = false;
            this.message.create('error', 'Failed to save customize');
          }
        })
    } else {
      this.BaseService
        .postData(CUSTOMIZE_PAYMENT, formData)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res: any) => {
            this.loading = false;
            this.message.create('success', 'Customize saved successfully');
            this.getDataCustomize(this.tabMode);
          },
          error: (err: any) => {
            this.loading = false;
            this.message.create('error', 'Failed to save customize');
          }
        })
    }
  }

  getDataCustomize(device_type: string) {
    this.loading = true;
    this.BaseService
      .getData(CUSTOMIZE_PAYMENT, { device_type })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.loading = false;
          this.formGroup.patchValue(res.data);
          this.uploadedImage = res.data.logo_path;
          this.photoName = res.data.logo_path;
          this.formGroup.get('logo')?.setValue(res.data.logo_path);
          this.companyName = res.data.company_name;
          this.isAvailabeCustomize = true;
          this.formGroup.get('background_color')?.setValue(res.data.background_color);
          this.customColors = res.data.background_color;
        },
        error: (err: any) => {
          this.loading = false;
          this.message.create('error', 'Failed to get customize data');
        }
      })
  }

  ngOnInit(): void {
    this.getDataCustomize(this.tabMode);
  }
}
